<template>
  <div class="item" v-observe-visibility="observeVisibility">
    <Flex row @click="scrollTo" :class="{ 'cursor-pointer': hasDataVisible }" v-if="visible">
      <Flex name>
        <div :title="nameTitle">{{ group }}</div>
      </Flex>
      <Flex progress>
        <ProgressBar
          v-if="hasData"
          :percentage="progress"
          :color="secondaryColor"
          :showText="false"
          :title="progressBarTitle"
          class="bar"
        />
      </Flex>
    </Flex>
  </div>
</template>

<script>
import Flex from '@wizer/core/components/flex/Flex'
import events from '@wizer/core/events'
import { mapGetters } from 'vuex'
import ProgressBar from '@/components/sustainability/ProgressBar'
import TrackVisibility from '@/mixins/TrackVisibility'

export default {
  name: 'GroupProgressItem',
  components: {
    ProgressBar,
    Flex,
  },
  props: {
    group: String,
    hasData: Boolean,
    hasDataVisible: Boolean,
    progress: Number,
    nameTitle: String,
    progressBarTitle: String,
  },
  mixins: [TrackVisibility],
  computed: {
    ...mapGetters('Visualizations', ['secondaryColor']),
  },
  methods: {
    scrollTo() {
      if (this.hasDataVisible) {
        events.publish('scroll-to-group', this.group)
      }
    },
  },
}
</script>

<style lang="postcss" scoped>
.item {
  min-height: 2.4rem;
}
.row {
  @apply border-t border-l px-3 py-2 items-center;
}
.name {
  @apply w-2/3 pr-1 overflow-hidden;
}
.progress {
  @apply w-1/3;
}
.bar {
  @apply w-full h-3;
}
</style>
